import React, { ComponentType, ReactElement, startTransition, useEffect, useState } from 'react'
import { Navigate } from 'react-router'
import { LoadingPlaceholderContainer } from 'ui/atoms'

const ROUTE_LOADING_PLACEHOLDER_HEIGHT_PX = 300

type PrivateRouteProps = {
  component?: ComponentType<any>
  title?: string
}

export function PrivateRoute({ component: Component, title, ...rest }: PrivateRouteProps): ReactElement {
  // Used to be able to show a placeholder until we are ready to render the component.
  // This makes navigation instant even if the component we are navigating to takes time to render.
  const [showRenderPlaceholder, setShowRenderPlaceholder] = useState(true)

  useEffect(() => {
    // Wait until after first paint to start rendering the component
    startTransition(() => {
      setShowRenderPlaceholder(false)
    })
  }, [])

  useEffect(() => {
    document.title = `${title ? title + ` - ` : ``}Aurora by Sigholm`
  }, [title])

  // Show placeholder until we are ready to render the component
  if (showRenderPlaceholder) {
    return <LoadingPlaceholderContainer height={ROUTE_LOADING_PLACEHOLDER_HEIGHT_PX} />
  }

  return Component ? <Component {...rest} /> : <Navigate replace to="/login" />
}
